import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifInput,
  MotifFormField,
  MotifErrorMessage,
} from '@ey-xd/motif-react';
import { Field, reduxForm } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';

const DeleteGroupConfirmationModal = ({
  showDeleteGroupConfirmationModal,
  toggleShowDeleteGroupConfirmationModal,
  handleConfirm,
  apiErrorMessage,
}) => {
  const [confirmationInputText, setConfirmationInputText] = useState('');
  const [saveEnabled, setSaveEnabled] = useState(false);

  useEffect(() => {
    if (showDeleteGroupConfirmationModal) {
      setConfirmationInputText('');
      setSaveEnabled(false);
    }
  }, [showDeleteGroupConfirmationModal]);

  const handleConfirmationInput = (e) => {
    setConfirmationInputText(e.target.value);
    if (/^Delete$/gi.test(e.target.value)) {
      setSaveEnabled(true);
    } else {
      setSaveEnabled(false);
    }
  };
  const showHideConfirmationModal = () => {
    setConfirmationInputText('');
    toggleShowDeleteGroupConfirmationModal();
  };

  const closeButtonProps = {
    title: 'Delete Group',
    'aria-label': 'Delete Group',
    'data-testid': 'close',
  };

  return (
    <MotifModal
      show={showDeleteGroupConfirmationModal}
      data-testid="divDeleteGroupModal"
      onClose={showHideConfirmationModal}
      variant="default"
      size="lg"
    >
      <MotifModalHeader
        closeButtonProps={closeButtonProps}
        data-testid="mdHdrDeleteGroups"
      >
        Delete Group
      </MotifModalHeader>
      <MotifModalBody>
        {(apiErrorMessage && (
          <MotifErrorMessage variant="error">
            {apiErrorMessage}
          </MotifErrorMessage>
        )) ||
          null}
        <MotifFormField>
          <div className="row">
            <div className="field col-md-12">
              <Field
                name="EntityGroupName"
                component={formHelpers.renderField}
                type="text"
                label="Group Name"
                dataTestId="txtGroupName"
                className="w-100"
                disabled={true}
              />
            </div>
          </div>
        </MotifFormField>
        <span className="margin-bottom-1">
          Type &apos;Delete&apos; in the box below to confirm you want to make
          this change.
        </span>
        <div className="row">
          <div className="field col-md-12">
            <MotifInput
              type="text"
              name="confirmationInput"
              id="confirmationInput"
              onChange={handleConfirmationInput}
              value={confirmationInputText}
              required={true}
              placeholder="Delete"
              data-testid="txtDelete"
            />
          </div>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          className="right mt-3"
          onClick={() => {
            setConfirmationInputText('');
            toggleShowDeleteGroupConfirmationModal();
          }}
          data-testid="btnCancel"
          type="button"
        >
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          className="right mt-3"
          data-testid="btnConfirm"
          onClick={handleConfirm}
          type="button"
          disabled={!saveEnabled}
        >
          Confirm
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

DeleteGroupConfirmationModal.propTypes = {
  showDeleteGroupConfirmationModal: PropTypes.bool,
  toggleShowDeleteGroupConfirmationModal: PropTypes.func,
  modifiedMappingsArray: PropTypes.array,
  handleConfirm: PropTypes.func,
  deleteGroup: PropTypes.func,
  theme: PropTypes.string,
  initialValues: PropTypes.shape({
    EntityGroupID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    EntityGroupName: PropTypes.string,
  }),
};
export default reduxForm({
  form: 'deleteGroupForm',
  enableReinitialize: true,
})(DeleteGroupConfirmationModal);
